// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2z-Ct","buttons":"SendReceipts_buttons__2SK8D","email":"SendReceipts_email__2ofT5","bookApptTitle":"SendReceipts_bookApptTitle__3TifG"};